import { schema } from "normalizr";

const SupplierSchema = new schema.Entity("suppliers");
const SupplierArraySchema = new schema.Array(SupplierSchema);

export { SupplierSchema, SupplierArraySchema };